/** Whether the referral field currently indicates the supporting form is attached. */
export function isReferralLinkChecked(survey, link) {
    const question = survey.getQuestionByName(link.fieldName);
    const value = question ? question.value : survey.getValue(link.fieldName);
    if (link.choiceValue) {
        if (Array.isArray(value)) {
            return value.map(String).includes(link.choiceValue);
        }
        return value != null && String(value) === link.choiceValue;
    }
    return value === true || value === 'true' || value === 1 || value === '1';
}
/** Check or uncheck the referral field that links to a supporting form. */
export function setReferralLinkChecked(survey, link, checked) {
    const question = survey.getQuestionByName(link.fieldName);
    if (link.choiceValue) {
        const current = question ? question.value : survey.getValue(link.fieldName);
        const list = Array.isArray(current) ? current.map(String) : [];
        const next = checked
            ? list.includes(link.choiceValue)
                ? list
                : [...list, link.choiceValue]
            : list.filter((item) => item !== link.choiceValue);
        if (question) {
            question.value = next;
        }
        else {
            survey.setValue(link.fieldName, next);
        }
        return;
    }
    const next = checked ? true : false;
    if (question) {
        question.value = next;
    }
    else {
        survey.setValue(link.fieldName, next);
    }
}
